export default class MonitoringReportModeSplitViewModel {
    enabled: boolean = false;
    startEnd: string = "0";
    start: string = "0";
    end: string = "0";
    direction: string = "0";
}